// extracted by mini-css-extract-plugin
export var banner = "_hb-0";
export var closeButton = "_hb-2";
export var greenCheckmark = "_hb-3";
export var hereLink = "_hb-4";
export var titleIcon = "_hb-1";